import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";

import { EntityShape } from "../../policies/proptypes";
import Entity from "../../shared/components/Entity";
import VirtualizedTable from "../../shared/components/VirtualizedTable";

class ServiceEntities extends Component {
  headerRenderer = column => (
    <div className="p-table__header-cell--muted">{column.label}</div>
  );

  cellRenderer = (column, entity) => {
    const { parentUrl } = this.props;
    const { name } = entity;

    if (column.key === "name") {
      return (
        <div className="p-table__cell">
          <Link
            className="u-hide-text-overflow"
            to={`${parentUrl}/groups/${name}`}
          >
            <Entity type={entity.type}>{name}</Entity>
          </Link>
        </div>
      );
    }
    return <div className="p-table__cell">{entity[column.key] || "N/A"}</div>;
  };

  render = () => {
    const { entities } = this.props;
    const columns = [
      { key: "name", label: "Groups/users of this service", minWidth: 200 },
      { key: "email", label: "Email address", minWidth: 300 }
    ];

    return (
      <div style={{ gridArea: "service-entities" }}>
        <VirtualizedTable
          cellRenderer={this.cellRenderer}
          columns={columns}
          headerRenderer={this.headerRenderer}
          rows={entities}
        />
      </div>
    );
  };
}

ServiceEntities.propTypes = {
  entities: PropTypes.arrayOf(EntityShape).isRequired,
  parentUrl: PropTypes.string.isRequired
};

export default ServiceEntities;
